import { CandidateComparison } from "./CandidateComparison";
import { ResourceIcon } from "./icons";
import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const RESOURCE_ITEMS = [
  "Role blueprint creation",
  "Competency models and success criteria",
  "Structured interview guides",
  "Candidate assessment frameworks",
  "Side-by-side evaluation views",
];

export function ProductPeek({ theme }: { theme: Theme }) {
  return (
    <section
      style={{
        padding: "clamp(72px, 12vw, 120px) 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader
        theme={theme}
        kicker="Decision support & resources"
        title="Tools and resources that improve decision quality."
      >
        Rarion equips your team with practical, expert-informed frameworks.
      </SectionHeader>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 clamp(20px, 5vw, 40px)" }}>
        <CandidateComparison theme={theme} />
        <ResourceStrip theme={theme} />
      </div>
    </section>
  );
}

function ResourceStrip({ theme }: { theme: Theme }) {
  return (
    <div
      style={{
        marginTop: 48,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: 12,
      }}
    >
      {RESOURCE_ITEMS.map((x, i) => (
        <div
          key={x}
          style={{
            padding: "20px 18px",
            background: theme.bg,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius,
            minHeight: 120,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 6,
              background: theme.accentSoft,
              color: theme.accentFg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ResourceIcon i={i} />
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              color: theme.fg,
              lineHeight: 1.3,
            }}
          >
            {x}
          </div>
        </div>
      ))}
    </div>
  );
}
